import {Field,ErrorMessage } from "formik";
import React  from "react";

function Input(props){
    const {questionName, name , ...rest} = props
    return (
        <>
            {!!questionName &&
                <h2 className="card_medicine_heading">{questionName}</h2>
            }
            <label htmlFor={name} >input label</label>
            <Field name={name} id={name} {...rest} />
            <ErrorMessage name={name} />
        </>
    )
}
export default Input 